import React from "react";

export default function Quotes() {

    const svg = `
<svg width="76px" height="85px" viewBox="0 0 76 85" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon-citation" transform="translate(1.000000, 1.000000)" stroke="#000021">
            <path d="M23.3979728,0.695030241 C39.5574148,-2.84709633 55.6120304,7.49776794 59.2580948,23.8002716 C62.9036015,40.1016713 52.7605281,56.1883465 36.6010861,59.7304731 C32.6321786,60.600411 28.6727501,60.6136587 24.897883,59.9247739 C27.3256188,67.9578997 31.1685115,75.4522822 36.2977585,82 C18.8915509,73.3431244 5.3326968,57.1521229 0.742079278,36.6257837 C-2.90398509,20.32328 7.23964589,4.23660482 23.3979728,0.695030241 Z" id="Stroke-1"></path>
            <path d="M55.6989864,31.3475151 C63.7787074,29.5764518 71.8060152,34.748884 73.6290474,42.9001358 C75.4518008,51.0508357 70.3802641,59.0941732 62.3005431,60.8652365 C60.3160893,61.3002055 58.336375,61.3068294 56.4489415,60.962387 C57.6628094,64.9789498 59.5842558,68.7261411 62.1488793,72 C53.4457755,67.6715622 46.6663484,59.5760614 44.3710396,49.3128918 C42.5480075,41.16164 47.6198229,33.1183024 55.6989864,31.3475151 Z" id="Stroke-1"></path>
        </g>
    </g>
</svg>`;

    return (
        <i className="icon" dangerouslySetInnerHTML={{__html: svg}}/>
    )
}
